var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBellCrossed = function SvgBellCrossed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.613 15.538a1.188 1.188 0 0 1-1.673.155L2.996 4.933a1.188 1.188 0 1 1 1.519-1.827l12.944 10.759c.505.42.574 1.169.154 1.673z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.202V8a6 6 0 0 0-9.614-4.79L16 11.203zM4.046 7.256A6 6 0 0 0 4 8v3.586l-.707.707A1 1 0 0 0 4 14h8.16L4.045 7.256zm3.832 9.865A3 3 0 0 0 13 15H7a3 3 0 0 0 .878 2.121z"
  })));
};
export default SvgBellCrossed;